<div class="app-threshold-edit">
  <div class="edit-wrap align-items-center" *ngIf="!isFormVisible">
    <button mat-icon-button extended (click)="onEditClick();" [disabled]="loading" class="d-flex align-items-center gap5">
      <img alt="edit" matTooltip="Edit" class="h-25 cursor"
        src="../../../../assets/images/trl-profile-widget-edit.svg">
      <span class="edit-threshold"> {{ MESSAGES?.THRESHOLDEDIT_EDIT_LABEL }}</span>
    </button>
  </div>
  <ng-container *ngIf="isFormVisible">
    <form [formGroup]="editForm" class="form-edit">
      <app-number formControlName="lowerLimit" [label]="'Lower Threshold'" [appearance]="'outline'"
        [className]="'-w-auto'" [negativeNumber]="true"></app-number>
      <app-number formControlName="upperLimit" [label]="'Upper Threshold'" [appearance]="'outline'"
        [className]="'-w-auto'" [negativeNumber]="true"></app-number>
      <div class="form-action d-flex flex-column ">
        <button type="submit" mat-icon-button (click)="onFormSubmit()"
          [disabled]="editForm?.pristine || editForm?.errors || this.editForm.invalid">
          <img alt="submit" class="h-20" src="../../../../assets/images/dover-add-icon.svg">
        </button>
        <button type="button" mat-icon-button (click)="onFormCancel()">
          <img alt="cancel" class="h-20" src="../../../../assets/images/dover-close-icon.svg">
        </button>
      </div>
    </form>
    <div class="form-error"
      *ngIf="editForm?.errors?.['lowerLimit'] || editForm?.get('lowerLimit')?.errors?.['required'] || editForm?.get('upperLimit')?.errors?.['required']">
      <mat-error
        *ngIf="(editForm?.get('lowerLimit')?.errors?.['required'] || editForm?.get('upperLimit')?.errors?.['required']) else nextCondition">
        <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.THRESHOLDEDIT_FORM_ERROR_REQUIRED }}
      </mat-error>
      <ng-template #nextCondition>
        <mat-error *ngIf="editForm?.errors?.['lowerLimit']">
          <em class="fas fa-exclamation-circle mr-2"></em>{{ MESSAGES?.THRESHOLDEDIT_FORM_ERROR_LOWERLIMIT }}
        </mat-error>
      </ng-template>
    </div>
  </ng-container>
</div>